import { ReactNode } from "react";
import { styled } from '@mui/system';
import { useMediaQuery } from '@mui/material';

interface GridItemProps {
    children: ReactNode;
    columnSpan?: number;
    rowSpan?: number;
    columnSpanMobile?: number;
    rowSpanMobile?: number;
}

const GridItemContainer = styled('div')<{ columnSpan: number; rowSpan: number }>(({ columnSpan, rowSpan }) => ({
    gridColumn: `span ${columnSpan}`,
    gridRow: `span ${rowSpan}`,
}));

export const GridItem = ({
    children,
    columnSpan = 1,
    rowSpan = 1,
    columnSpanMobile,
    rowSpanMobile
}: GridItemProps) => {
    const isMobile = useMediaQuery('(max-width:1024px)');

    const effectiveColumnSpan = isMobile && columnSpanMobile !== undefined ? columnSpanMobile : columnSpan;
    const effectiveRowSpan = isMobile && rowSpanMobile !== undefined ? rowSpanMobile : rowSpan;

    return (
        <GridItemContainer columnSpan={effectiveColumnSpan} rowSpan={effectiveRowSpan}>
            {children}
        </GridItemContainer>
    );
}; 